// extracted by mini-css-extract-plugin
export default {"image":"EmployeeCard_image__1SQHV","name":"EmployeeCard_name__HRPrY","email-container":"EmployeeCard_email-container__afxb2"};